import { AccordionItemProps } from 'src/components/accordion';
import { IComponent } from 'src/interfaces';

import { CommonFormProps } from '../FormSelector.interface';
import { KNOWN_USER_TYPES } from './constants';

export interface CODThankYouFormProps extends Omit<CommonFormProps, 'config'> {
  componentDetails: IComponent;
  saveToken?: object;
}

export enum CustomerTypes {
  UNKNOWN = 'unknownCustomer',
  KNOWN = 'knownCustomer',
}

export type CustomerPath =
  | CustomerTypes
  | 'ads.content.unknownCustomer'
  | 'ads.content.knownCustomer';

interface ICodThankYouElement {
  top?: number;
  left?: number;
  width?: number;
  height?: number;
  value: string;
}

type ILabelType = ICodThankYouElement & {
  font?: string;
  color?: string;
  fontSize?: string;
  lineHeight?: string;
};

interface ICodThankyou {
  label?: ILabelType[];
  media?: ICodThankYouElement[];
  width?: string;
  height?: string;
  background?: string;
  backgroundColor?: string;
  mop?: {
    background: string;
  };
}

export interface ICodThankYouConfig {
  unknownCustomer: ICodThankyou;
  knownCustomer?: ICodThankyou;
  active: boolean;
  ads?: {
    isAdsEnabled?: boolean;
    showPlaceholder?: boolean;
    content: {
      unknownCustomer: ICodThankyou;
      knownCustomer?: ICodThankyou;
    };
  };
}

export interface CodThankyouKnownMopProps {
  items: AccordionItemProps[];
  backgroundItem: AccordionItemProps;
  handleOnChange: (key: string, value: unknown, fieldOnChange?: any) => void;
  onChangeActiveTab: (val: KNOWN_USER_TYPES) => void;
  activeTab: string;
  customerPath: CustomerPath;
  isMopEnabled: boolean;
}

const codThankyouCommonConfigSchema = {
  type: 'object',
  properties: {
    top: {
      type: 'number',
    },
    left: {
      type: 'number',
    },
    width: {
      type: 'number',
    },
    height: {
      type: 'number',
    },
    value: {
      type: 'string',
    },
  },
  required: ['value'],
};

const CodThankYouConfigSchema = {
  type: 'object',
  properties: {
    label: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          ...codThankyouCommonConfigSchema.properties,
          font: { type: 'string' },
          color: { type: 'string' },
          fontSize: { type: 'string' },
          lineHeight: { type: 'string' },
          value: {
            type: 'string',
          },
        },
      },
      minItems: 1,
    },
    media: {
      type: 'array',
      items: codThankyouCommonConfigSchema,
    },
    background: { type: 'string' },
    backgroundColor: { type: 'string', minLength: 1 },
    width: { type: 'string' },
    height: { type: 'string' },
    mop: {
      type: 'object',
      properties: {
        background: {
          type: ['string', 'null'],
        },
      },
      if: {
        properties: {
          background: { type: 'string' },
        },
      },
      then: {
        properties: { background: { type: 'string', minLength: 1 } },
      },
    },
  },
};

export const CodThankYouComponentConfigSchema = {
  type: 'object',
  properties: {
    knownCustomer: CodThankYouConfigSchema,
    unknownCustomer: CodThankYouConfigSchema,
    active: { type: 'boolean' },
    ads: {
      type: 'object',
      properties: {
        isAdsEnabled: { type: 'boolean' },
        showPlaceholder: { type: 'boolean' },
        content: {
          type: 'object',
          properties: {
            knownCustomer: CodThankYouConfigSchema,
            unknownCustomer: CodThankYouConfigSchema,
          },
          required: ['unknownCustomer'],
        },
      },
      required: ['content'],
    },
  },
  required: ['unknownCustomer', 'active'],
};
